$(document).ready(function () {
    const navItem = $('#nav-item-products');
    const productList = $('#nav-product-list');
    if (navItem.length === 0 || productList.length === 0) {
        return;
    }

    $('body')
        .on('click', '#nav-item-products', (e) => {
            e.preventDefault();
            const { left, bottom } = e.target.getBoundingClientRect();
            productList.css({
                display: 'block',
                top: bottom + 4,
                left,
            });
        })
        .on('click', (e) => {
            if (
                e.target.id !== 'nav-item-products' &&
                !e.target.closest('#nav-product-list')
            ) {
                productList.hide();
            }
        });
});
